const createValueMap = <T extends readonly string[]>(values: T) =>
  values.reduce(
    (acc, value) => ({
      ...acc,
      [value]: value,
    }),
    {} as { [K in T[number]]: K },
  );

export const SURVEY_CATEGORIES = [
  "customer_feedback",
  "product_research",
  "user_experience",
    "market_research",
    "employee_survey",
    "comprehensive_survey",
    "other",
] as const;

export type SurveyCategory = (typeof SURVEY_CATEGORIES)[number];

export const SURVEY_CATEGORY_ENUM = createValueMap(SURVEY_CATEGORIES);
